module.exports = {
  psyLandingPage: {
    announcement: {
      title: '本ゲームの開催期間は終了しました',
      text: {
        '1':
          '新型コロナウィルスの影響で運営を当面停止しておりましたが、この度、感染予防対策を徹底したうえで2020年7月8日（水）より運営を再開させていただくことに致しました。開催期間は2020年9月30日（水）までです。つきましては、ご参加いただくお客様には、以下の感染予防対策へのご協力をお願い申し上げます。',
        '2': '<運営方針及びお客様へのお願い>'
      },
      warnings: {
        '1':
          '「密閉」「密集」「密接」の3密を避けるため、スタート地点として利用しておりました岡崎ビルは利用せず、お客様には予約日時に渋谷宮益坂へお越しいただき、ご自身で遠隔スタートしていただきます。具体的なスタート方法につきましては、ご予約後にご案内させていただきます。',
        '2': 'マスクは必ず着用のうえ、ご参加ください。',
        '3':
          'ご予約は2名様まで可能です。3名様以上でのご参加は承っておりません。',
        '4':
          '同一スロットに他のお客様がいらっしゃった場合、2m以上の距離を空けてご体験ください。',
        '5': '電車等をご利用のうえでのご参加は極力ご遠慮ください。',
        '6': 'ご体調の悪い方はご参加をご遠慮ください。',
        '7':
          '体験中に何かトラブル等がございましたら、弊社LINE公式アカウントにてご連絡ください。'
      }
    },
    importantNotice: {
      title:
        '現在、ゲーム終了後のフォトセッションにおきまして、撮った写真が正常に保存されない場合があることを確認しております。原因調査中ではございますが、本件は返金対象外となりますことをご了承ください。'
    },
    keyVisual: {
      info: {
        '1': '新感覚AR謎解きゲーム',
        '2': '大好評開催中'
      }
    },
    story: {
      subtitle: 'あらすじ',
      intro: {
        '1': '「…監視官候補生、',
        '2': 'あんたならどうする？」'
      },
      main: {
        '1':
          '211X年、シビュラシステム運用下にある東京のS区でガス兵器による事件が発生したとの情報が入った。',
        '2':
          '実地訓練として公安局刑事課一係に配属された監視官候補生は、常守、狡噛とともに犯行現場へ向かう。',
        '3':
          '謎を解き明かして、隠された真実を知ったとき、監視官候補生の下す「正義」とは――。'
      }
    },
    features: {
      subtitle: '本ゲームの特徴',
      main: {
        '1': {
          '1': '原作キャスト新規撮り下ろし音声で語られるオリジナルストーリー！',
          '2': '狡噛、常守らと共に事件を解決に導け！'
        },
        '2': {
          '1':
            '今作オリジナルキャラクターとなる<ruby>加巳野<rt>かみの</rt>正<rt>ただし</rt></ruby>。',
          '2': '潜在犯を強く憎む彼はどのようにストーリーに関わるのか？'
        },
        '3': {
          '1': 'あなたのスマホがドミネーターに！',
          '2': 'シビュラの神託に従い、潜在犯を罰するのか、それとも……？'
        }
      }
    },
    trailer: {
      subtitle: '遊び方',
      id: 'ID-CTRL :0457'
    },
    instructions: {
      subtitle: '参加方法',
      taro: '色相をクリアに保ちましょう',
      '1': {
        title: '日時を選ぶ',
        text: '遊びたい日時を決め、WEBから予約'
      },
      '2': {
        title: '予約メールを確認',
        text: '当日の持ち物や注意事項が記載されています'
      },
      '3': {
        title: '渋谷でゲーム開始',
        text: '出発の準備をしゲーム開始'
      }
    },
    characters: {
      subtitle: 'キャラクター',
      kogami: {
        id: '00475-AEDF-52510-2',
        name: '狡噛 慎也',
        furigana: 'SHINYA KOGAMI',
        bio: {
          '1': '公安局刑事課一係に所属する執行官。',
          '2':
            '自虐的なまでに鍛え上げられた肉体と捜査への執念には同じ執行官の間からも畏怖の眼差しを向けられている。'
        }
      },
      tsunemori: {
        id: '00475-AECJ-30157-1',
        name: '常守 朱',
        furigana: 'AKANE TSUNEMORI',
        bio: {
          '1': '公安局刑事課一係に所属する新米監視官。',
          '2':
            '天真爛漫だが押しの弱い不器用な一面も。狡噛に振り回されながらも、事件の捜査にあたっていく。'
        }
      },
      karanomori: {
        id: '00475-AEUW-06859-6',
        name: '唐之杜 志恩',
        furigana: 'SHION KARANOMORI',
        bio: {
          '1': '公安局総合分析室の分析官。',
          '2':
            '執行官、監視官たちの捜査活動を様々な分析データでバックアップする。おしゃべりでナイスバディな美女。'
        }
      },
      kamino: {
        id: '00475-AEAJ-37564-1',
        name: '加巳野 正',
        furigana: 'TADASHI KAMINO',
        bio: {
          '1': '公安局キャリア研修所の教官。',
          '2':
            '監視官候補生であるプレイヤーにドミネーターの扱い方を指導している。'
        }
      }
    },
    about: {
      subtitle: '『PSYCHO-PASS サイコパス』とは',
      main: {
        '1':
          '魂を数値化する巨大監視ネットワーク・シビュラシステムが人々の治安を維持している近未来。',
        '2':
          '変わりゆく世界で、犯罪に関する数値〈犯罪係数〉を測定する銃〈ドミネーター〉を持つ刑事たちは、犯罪を犯す前の〈潜在犯〉を追う。'
      },
      link: 'アニメ公式サイトへ'
    },
    information: {
      subtitle: 'インフォメーション',
      komissaSays: 'こちらは公安局刑事課です'
    },
    footer: {
      jasrac: 'JASRAC許諾第9024096002Y45040号',
      copyright: {
        '1': 'サイコパス製作委員会',
        '2': 'Pretia Technologies, Inc.'
      }
    }
  },
  landingPage: {
    information: {
      playTime: 'プレイ時間',
      variableTimeWarning: '※所要時間は個人差があります',
      limitedTimeWarning: '※制限時間あり',
      playerCapacity: 'プレイ人数',
      price: '料金',
      location: {
        label: '開始地点',
        warning: '※具体的な行き先はゲーム開始後に指示がございます'
      },
      weekday: '平日',
      holiday: '休日',
      noPlayerLimit: '1人〜制限なし',
      belongings: {
        label: '持ち物',
        value: '当アプリに対応したスマートフォン'
      }
    },
    devices: {
      subtitle: '対応スマートフォン',
      rental: {
        title: 'スマホレンタルにつきまして',
        text: {
          '1':
            '店舗閉鎖に伴い、誠に勝手ながら、スマホレンタルのご案内も廃止とさせていただきます。',
          '2':
            'つきましては、原則としまして、対応端末をお持ちの方のみのご案内となりますこと、予めご了承くださいませ。',
          '3':
            '対応端末をお持ちでないお客様におかれましては、お連れ様との端末シェアにご同意いただける場合に限り、ご予約を承ることが可能です。<br/>このような場合でも、参加料につきましては、人数分をお支払い頂きますようお願いいたします。'
        }
      }
    },
    faq: {
      subtitle: 'よくある質問',
      allButton: '全てのFAQはこちら'
    },
    warning: {
      subtitle: '注意事項',
      '1': 'アプリの通知と位置情報は許可してください',
      '2': '遊ぶ前は十分スマホを充電してきてください',
      '3': 'ゲーム中のアプリ切替え・画面オフはできません',
      '4': '遊んだ後はネタバレはご遠慮下さい',
      '5': '街の人にゲームのことを聞かないでください',
      '6': '人にぶつかると危ないので、走らないでください',
      '7': '歩きスマホはご遠慮下さい',
      '8': '集団で道路にたまったりしないでください',
      '9': 'キャッチについていかないでください',
      '10': '地図にない建物はゲームをプレイする上で考慮する必要はありません',
      '11': '写真撮影は人が映りこまないようにお願いします',
      '12': '歩きやすい靴でお越しください'
    },
    footer: {
      terms: '利用規約',
      policy: 'プライバシーポリシー',
      salesNotice: '特定商取引法に基づく表記',
      contact: 'お問い合わせ',
      disclaimer: '免責事項'
    },
    book: {
      nextStepShort: '予約'
    }
  }
};
